import './style.less';

import {
  Badge,
  Box,
  Flex,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { AlertIcon } from '@tonic-one/react-icons';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalApi } from '@Apis';

import { useTextButtonStyle } from '../style';
import MessageList from './MessageList';
import { AllNotificationDict, generateNotifications } from './notification';
import { AllTaskDict, generateTasks } from './task';

export default function NotificationAndTask() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [panel, setPanel] = useState<'notification' | 'task'>('notification');

  const handleOpenMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleCloseMenu = () => {
    setIsOpen(false);
    setPanel('notification');
  };

  const [data, setData] = useState(null as any);
  useEffect(() => {
    GlobalApi.getNotification().then((res) => {
      setData(res.data || null);
    });
  }, []);

  const notifications = data ? generateNotifications(data) : {};
  const notificationCount = computeCount(notifications);

  const tasks = data ? generateTasks(data) : {};
  const taskCount = computeCount(tasks);
  const textButtonStyle = useTextButtonStyle();
  return (
    <Popover
      trigger="hover"
      arrow={false}
      onOpen={handleOpenMenu}
      onClose={handleCloseMenu}
    >
      <PopoverTrigger>
        <Flex align="center" cursor="pointer" {...textButtonStyle}>
          <Badge alignItems="center">
            <Icon as={AlertIcon} size={16} m="16px 16px" />
          </Badge>
        </Flex>
      </PopoverTrigger>
      <PopoverContent maxWidth="580px" p="0">
        <Box width="580px">
          <Flex width="100%" height="40px" cursor="pointer">
            <Flex
              width="50%"
              align="center"
              justify="center"
              fontSize="14px"
              background={
                panel === 'notification'
                  ? colorStyle.background.tertiary
                  : colorStyle.background.secondary
              }
              onClick={() => setPanel('notification')}
            >
              {t('header.notification.notification')}&nbsp;(
              {notificationCount})
            </Flex>
            <Flex
              width="50%"
              align="center"
              justify="center"
              fontSize="14px"
              background={
                panel === 'task'
                  ? colorStyle.background.tertiary
                  : colorStyle.background.secondary
              }
              onClick={() => setPanel('task')}
            >
              {t('header.notification.task')}&nbsp;({taskCount})
            </Flex>
          </Flex>
          {panel === 'task' ? (
            <MessageList isOpen={isOpen} type={panel} messages={tasks} />
          ) : (
            <MessageList
              isOpen={isOpen}
              type={panel}
              messages={notifications}
            />
          )}
        </Box>
      </PopoverContent>
    </Popover>
  );
}

function computeCount(all: AllNotificationDict | AllTaskDict) {
  let count = 0;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  for (const [_, dict] of Object.entries(all)) {
    for (const item of Object.values(dict)) {
      if (!item.hidden) {
        count += 1;
      }
    }
  }
  return count;
}
